import { Map } from 'immutable';
import _ from 'lodash';

import { ActionTypes } from '../constants/AppConstants';
import BaseStore from './BaseStore';

class OrderHistoryStore extends BaseStore {

    getInitialState () {
        return new Map({
            loading: false,
            orders: null,
            pagination: null,
            currentOrder: null,
            currentOrderRefundCalculations: null
        });
    }

    handleSearching () {
        this.setState(this.state.set('loading', true));
    }

    handleOrders ({ orders, pagination }) {
        this.setState(this.state.merge({
            loading: false,
            orders,
            pagination
        }));
    }

    handleSearchFailed () {
        this.setState(this.state.set('loading', false));
    }

    handleOrderDetails ({ order, refundCalculations }) {
        this.setState(this.state.merge({
            currentOrder: order,
            currentOrderRefundCalculations: refundCalculations
        }));
    }

    getOrder (orderId) {
        let order = this.state.get('currentOrder');
        if (_.result(order, 'id') === orderId) {
            return order;
        }

        const orders = this.state.get('orders');
        return orders && orders.find((o) => o.id === orderId) || undefined;
    }

    getOrderRefundCalculations () {
        return this.state.get('currentOrderRefundCalculations');
    }

    getActionHandlers () {
        return {
            [ ActionTypes.CUSTOMER_ORDERS_SEARCHING ]: this.handleSearching,
            [ ActionTypes.CUSTOMER_ORDERS_LOADED ]: this.handleOrders,
            [ ActionTypes.CUSTOMER_ORDERS_FAILED ]: this.handleSearchFailed,
            [ ActionTypes.CUSTOMER_ORDER_LOADED ]: this.handleOrderDetails,
            [ ActionTypes.LOGGED_OUT ]: this.resetState,
            [ ActionTypes.ORDER_PAID ]: this.resetState,
            [ ActionTypes.REFUND_COMPLETE ]: this.resetState,
        };
    }

    /*
        * Returns the refund calculation for a specific order.
        * @param {number}
        *
        * Helper method added only for unit testing purposes.
    */
    getRefundCalculationForOrder(orderId) {
        const map = this.state.get('currentOrderRefundCalculations');
        if (!map || typeof map.get !== 'function') {
            return null;
        }
        return map.get(String(orderId)) || null;
    }


}

export default new OrderHistoryStore();
